import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {CustomFontSelection} from "./common-configuration";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Fonts)
@ComponentConfigurationClass("fonts")
export class FontsConfiguration {

    /**
     * @minimum 1
     * @maximum 32
     */
    public baseSize?: number;

    // FIXME: JSON schema generation tool limitation - only arrays can be pre-populated
    //        so list definition is passed as a first element of the schema array.
    /**
     * @format custom-font-selection
     */
    public fontType?: CustomFontSelection;

}
